import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const ShopBranch = () => (
  <div>Shop Branch</div>
);

export default withStyles(styles)(ShopBranch);

